import { DescriptionRequest, DescriptionRequestOptionsSelected } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import { Nullable } from '@/shared/types/app.types'

export interface servicePreformattedEditor<T> {
    getPreformatted: (laboratoryId: number, preformattedId: number) => Promise<T>
    updatePreformatted: (laboratoryId: number, preformattedId: number, request: DescriptionRequest) => Promise <T>
    updatePreformattedAndSolveExistingCodification: (laboratoryId: number, preformattedId : number, replaceInsteadOfAdd: boolean, request: DescriptionRequest) => Promise <T>
}

export enum DescriptionResponseEnum {
    FREE_TEXT = 1,
    TEXT_TEMPLATE = 2,
    SYNOPTIC_TEMPLATE = 3
}

export interface TemplateEditor {
    id: Nullable<number>
    title: Nullable<string>
    textEditionAllowed: Nullable<boolean>
}

export interface DescriptionResponseEditor {
    descriptionType: DescriptionResponseEnum
    id: Nullable<number>
    optionsSelected: DescriptionRequestOptionsSelected
    originalConcurrencyUpdatedAt: string
    template: Nullable<TemplateEditor>
    text: Nullable<string>
}

export interface LocalPreformattedDescriptionState {
    description: DescriptionResponseEditor
}
export const initialLocalPreformattedModalMacroState =
    (): LocalPreformattedDescriptionState => ({
        description: {
            id: null,
            descriptionType: DescriptionResponseEnum.FREE_TEXT,
            optionsSelected: {},
            originalConcurrencyUpdatedAt: '',
            template: null,
            text: null
        }
    })
